import { Observable, Subject } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { debounce, debounceTime, map } from 'rxjs/operators';
import { SharedService } from '../../service/shared.service';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit, OnChanges {

  @Input() items: Array<any> = [];
  @Input() placeHolder;
  @Input() type: string;
  @Output() onQueryChange = new EventEmitter<string>();
  @Output() itemSelected = new EventEmitter<any>();
  @Input() clearSearchInput: string;
  searchTxt: string;
  subject = new Subject();
  hideList = false;


  constructor(private filterService: SharedService) {
    this.items = [];
  }

  ngOnInit(): void {
    this.getSelectedFilters();
    this.subject
      .pipe(debounceTime(500))
      .subscribe((searchtext: string) => {
        this.onQueryChange.emit(this.searchTxt);
      });
  }

  getSelectedFilters() {
    let filters = this.filterService.getSelectedFilters();
    if (filters) {
      if (filters.inputSearched) {
        this.searchTxt = filters.inputSearched;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clearSearchInput && changes.clearSearchInput.currentValue) {
      this.searchTxt = '';     
    }
  }

  onChange(): void {
    this.hideList = false;
    this.subject.next(this.searchTxt);
  }

  onSelect(index: number): void {
    this.itemSelected.emit(this.items[index]);
    this.searchTxt = this.items[index].displayName;
    this.hideList = true;
  }

  onFocusOut(): void {
    // if (this.items) {
    //   this.items.length = 0;
    // }
    // this.searchTxt = '';
    this.hideList = true;
  }

  clear(): void {
    this.searchTxt = '';
    this.items = null;
    this.hideList = false;
    this.onQueryChange.emit(this.searchTxt);
  }

}
